import type { FixedAssetFormValues } from '../../../pages/app/partner/pages/partnerDashboardPage/components/FixedAssets/fixedAssetForm.ts';
import { toMoneyFromCents, type Money } from '../../../lib/Money.ts';
import type { EditableBillWire } from './editableBillMapping.ts';

function sumNetAmounts(bill: EditableBillWire): Money | null {
    const nets = bill.line_items.map((line) => line.net_amount);
    if (nets.length === 0 || nets.some((net) => net === null)) {
        return null;
    }
    const currency = nets[0]!.currency;
    if (currency === null || nets.some((net) => net!.currency !== currency)) {
        return null;
    }
    return toMoneyFromCents(nets.reduce((total, net) => total + net!.signed_amount, 0), currency);
}

function suggestedName(bill: EditableBillWire): string {
    const onlyLine = bill.line_items.length === 1 ? bill.line_items[0].name_or_description?.trim() : null;
    return onlyLine || (bill.relation_name ?? '').trim();
}

export function prefillFixedAssetFromBill(bill: EditableBillWire): Partial<FixedAssetFormValues> {
    return {
        name: suggestedName(bill),
        purchase_date: bill.normalized_date ?? '',
        purchase_money: sumNetAmounts(bill),
        residual_money: toMoneyFromCents(0, 'EUR'),
    };
}
